module.exports = __webpack_public_path__ + "img/1125-joy-yeah.213f3642.png";